import React, { useState } from 'react';
import '../assets/css/footer.css';
const Footer = (props) => {
  return (
    <div className={props.sidebarEnabler ? "footer  mt-2" : "footer_collapse  mt-2"}>
      <p className='p-0 m-0'>&copy; Copyright ExtraHourz Inc. </p>
    </div>
  )
};

export default Footer;
